<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog" >
      <form class="form" @submit.prevent="addMembers">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('appointments.add_members') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">

              <RequiredText :text="$t('appointments.oneOfThemRequired')"/>
              <Select2
                  :parent-id="'#'+id"
                  container-class="form-group col-12 col-md-12 col-lg-12 mt-auto mb-5"
                  :multiple="true"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`contacts`"
                  :isRequired="false"
                  :label="$t('appointments.label.invite_contacts')"
                  labelClass="form-label fs-6 text-black"
                  :placeholder-text="$t('appointments.label.invite_contacts')"
                  v-model="addFormData.contacts"
              >
                <option v-for="(contact, index) in filterContacts" :key="index" :value="contact.id">
                  {{ contact.fullname }}
                </option>
              </Select2>
              <Select2
                  :parent-id="'#'+id"
                  container-class="form-group col-12 col-md-12 col-lg-12 mt-auto mb-5"
                  :multiple="true"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`users`"
                  :isRequired="false"
                  :label="$t('appointments.label.invite_users')"
                  labelClass="form-label fs-6 text-black"
                  :placeholder-text="$t('appointments.label.invite_users')"
                  v-model="addFormData.users"
              >
                <option v-for="(user, index) in filterUsers" :key="index" :value="user.id">
                  {{ user.fullname }}
                </option>
              </Select2>
              <TagifyInput
                  :parent-id="'#'+id"
                  containerClass="form-group col-12 col-md-12 col-lg-12 mt-auto mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :label="$t('appointments.label.guest_emails')"
                  labelClass="form-label fs-6 text-black"
                  v-model="addFormData.guest_emails"
                  :name="`appointments-guest_emails`"
              />
            </div>
          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="cancel" id="submit_btn" btn-text="button.cancel" @click="closeModal" size="7px 30px"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="appointments.add" size="7px 30px" :isLoading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
  
<script setup>
  import {ref, defineEmits, defineProps, computed, onMounted, watch} from "vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import Select2 from "@/components/Select2.vue";
  import TagifyInput from "@/components/TagifyInput.vue";
  import {useSwal} from "@/composables/useSwal";
  import i18n from "@/plugins/i18n";


  const store = useStore()
  const {showSwal} = useSwal()
  
  const emits = defineEmits(['load'])
  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => ({
        appointment_id: '',
        users: [],
        contacts: [],
        guest_emails: [],
        sent_email: false
      })
    },
    appointment: Object
  })

  const isLoading = ref(false)
  const addFormData = ref(props.formData)
  const participantIds = ref([])

  const contacts = computed(() => store.getters["contacts/getContacts"])
  const filterContacts = computed(() => contacts.value?.filter(item => !participantIds.value.includes(item.id) ))
  const users = computed(() => store.getters["user/getUsers"])
  const filterUsers = computed(() => users.value?.filter(item => !participantIds.value.includes(item.id) ))

  watch(() => props.appointment, (newValue) => {
      let data = []
      if(newValue){
          newValue.participants?.filter((item) => {
              data.push(item?.participant?.id)
          })
      }
      participantIds.value = data
  })

  function closeModal(){
      $('#'+props.id).modal('toggle')
  }

  function addMembers(){
    isLoading.value = true
    
    if(addFormData.value.contacts.length > 0 || addFormData.value.users.length > 0 || addFormData.value.guest_emails.length > 0){
      closeModal()
      showSwal(
            '',
          i18n.global.t('appointments.swal.create_update'),
          'success',
          '#2DA333'
      ).then( async (result) => {
          if (result.value) {
              addFormData.value.sent_email = true
              try {
                store.dispatch('appointments/addMembersAppointment', addFormData.value)
                  .then((response) => {
                    emits('load')
                    window.toastr['success'](i18n.global.t('notification.appointment_added_participants'))
                  })
                  .catch(err => {
                  }).finally(() => isLoading.value = false)
              }catch (e) {
                
              }
          }else{
            store.dispatch('appointments/addMembersAppointment', addFormData.value)
              .then((response) => {
                emits('load')
                window.toastr['success'](i18n.global.t('notification.appointment_added_participants'))
              })
              .catch(err => {
              }).finally(() => isLoading.value = false)
          }
        }); 
    }
  }

  onMounted(() => {
    store.dispatch('contacts/loadContacts')
    store.dispatch('user/loadUsers')
  })
</script>

<style scoped></style>
  